export default "__VITE_ASSET__CxWvTK0y__"